export default "__VITE_ASSET__Cld7jYtg__"